<template>
  <div class="content">
    <h1>Hooray! You Just Saved Someone's Savour!</h1>

    <h1>Enjoy Your Reward!!!</h1>

    <h4>
      <router-link class="link-to-dashboard" :to="{ name: 'Dashboard' }"
        >Return To Dashboard</router-link
      >
    </h4>
    <div class="celebrate">
      <img src="../assets/memeImages/Celebrate2-mirror.png" alt="" />
      <img src="../assets/memeImages/Celebrate2.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.content {
  background: url("../assets/background/background24.jpeg") no-repeat center
    center fixed;
  height: 100vh;
  background-size: cover;
  color: #fff;

  h1 {
    margin-top: 20px;
    text-align: center;
  }

  h4 {
    margin-top: 20px;
    text-align: center;
  }

  .celebrate {
    margin-top: 20px;
    display: flex;
    flex-direction: row;

    img {
      height: 35%;
      width: 35%;
      border-radius: 8px;
    }
  }

  .link-to-dashboard {
    text-transform: none;
    //text-decoration: none;
    margin-top: 20px;
    text-align: center;
    color: #fff;
  }
}
</style>
